// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__NNOVS","text":"SelectPayment_text__2qfj8","title":"SelectPayment_title__31Fac","btn":"SelectPayment_btn__2EjPK"};